export default __webpack_public_path__ + "static/media/arrow-bold.ff6000eb.png";